import { OpenAPI } from "@/client";

OpenAPI.BASE = import.meta.env.VITE_API_URL;

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

const accessTokenFromUrl = urlParams.get("accessToken");

const accessToken = localStorage.getItem("accessToken") || accessTokenFromUrl;

if (accessToken) {
  OpenAPI.TOKEN = accessToken;
}
